<template>
  <div class="addAddress absolute">
    <div>
      <img
        src="@assets/images/storeapplyheader.png"
        style="width: 100%;"
        alt="商户入驻"
      />
    </div>
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div class="name">姓名</div>
        <input
          type="text"
          placeholder="请输入您的称呼"
          v-model="apply.name"
          required
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">联系电话</div>
        <input
          type="text"
          placeholder="请输入联系电话"
          v-model="apply.phone"
          required
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">商铺名称</div>
        <input
          type="text"
          placeholder="如果您已有商铺，请说明名称"
          v-model="apply.storeName"
          required
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">备注</div>
        <input
          type="text"
          placeholder="其他说明"
          v-model="apply.remark"
          required
        />
      </div>
    </div>
    <div></div>
    <div class="keepBnt bg-color-red" @click="submit">立即提交</div>
  </div>
</template>
<script type="text/babel">
import { storeApplyAdd } from "@api/store";
import attrs, { required, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import $store from "@/store";

export default {
  data() {
    return {
      id: 0,
      apply: {},
      address: {}
    };
  },
  mounted: function() {
    let id = this.$route.params.id;
    this.id = id;
    document.title = "商户入驻申请";
  },
  methods: {
    async submit() {
      let name = this.apply.name,
        phone = this.apply.phone;
      try {
        await this.$validator({
          name: [required(required.message("您的称呼"))],
          phone: [
            required(required.message("联系电话")),
            chs_phone(chs_phone.message())
          ]
        }).validate({ name, phone });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      try {
        let that = this;
        const data = {
          name: this.apply.name,
          phone: this.apply.phone,
          remark: this.apply.remark,
          storeName: this.apply.storeName,
          deptId: $store.state.app.deptId
        };
        storeApplyAdd(data).then(function() {
          that.$dialog.toast({
            mes: "提交申请成功，我们会在3个工作日内联系您！"
          });
          that.$router.go(-1);
        });
      } catch (e) {
        this.$dialog.error(e.msg);
      }
    }
  }
};
</script>
